import React, { FC } from 'react';
import { Button, Space } from '@myua/kit';
import copyToClipboard from 'copy-to-clipboard';
import { notification } from '../../../../general/kitMethods';
import { createHref } from '../model';
import { SharingLink } from '../../../api';

export const SuccessNotification: FC<{ link: string; copied: boolean }> = ({ link, copied }) => {
  return (
    <Space className="al-sharing-success-notification">
      {copied ? null : (
        <>
          <Button
            size="small"
            type="link"
            className="al-sharing-success-notification__button"
            onClick={() => {
              copyToClipboard(link);
              notification.destroy(link);
            }}
          >
            Copy link
          </Button>
          or
        </>
      )}

      <Button
        size="small"
        type="link"
        className="al-sharing-success-notification__button"
        onClick={() => {
          window.open(link, '_blank');
          notification.destroy(link);
        }}
      >
        Open in a new tab
      </Button>
    </Space>
  );
};

export const showSuccessNotification = async (
  sharingId: SharingLink['id'],
  messageFn: (copied: boolean) => string,
) => {
  const link = createHref(sharingId);

  let copied;
  try {
    await navigator.clipboard.writeText(link);
    copied = true;
  } catch (error) {
    copied = false;
  }

  notification.success({
    message: messageFn(copied),
    description: <SuccessNotification link={link} copied={copied} />,
    duration: 0,
    key: link,
  });
};
